module.exports = __webpack_public_path__ + "img/img4.15a5f057.png";